import React, {useEffect, useState} from 'react';
import WorkingCuttingMapTable from "../../../../components/UI/table/cutting/workingcuttingmap/WorkingCuttingMapTable";
import WorkingCuttingMapService from "../../../../API/orders/cutting/cuttingmap/WorkingCuttingMapService";
import WorkingCuttingMapUtil from "../../../../utils/cutting/WorkingCuttingMapUtil";
import {useLocation} from "react-router-dom";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../../Constants";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {WorkingCuttingMapTableFilterData} from "../../../../data/FilterTables/WorkingCuttingMapTableFilterData";
import CircularProgress from "@mui/material/CircularProgress";

const QueueCuttingMaps = () => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [isLoading, setIsLoading] = useState(true)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, WorkingCuttingMapTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [WorkingCuttingMapTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(pathname, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        const searchQuery = pagesData[pathname]?.searchQuery

        return {searchQuery, pageSize}
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const [minNumberCutting, setMinNumberCutting] = useState(null);
    const [maxNumberCutting, setMaxNumberCutting] = useState(null);
    const [unableCut, setUnableCut] = useState({});

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        WorkingCuttingMapService.getAllForCuttingWithOptimization().then(function (response) {
            const data = response.data;
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
            const minAndMax = WorkingCuttingMapUtil.getMinAndMax(data);
            setMinNumberCutting(minAndMax.min_numberCutting)
            setMaxNumberCutting(minAndMax.max_numberCutting)
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setIsLoading(false))
    }, []);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Порядок раскроя"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Порядок раскроя
                    </Typography>
                </Box>
                {isLoading ?
                    <Box sx={{
                        height: `calc(100vh - 450px)`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CircularProgress disableShrink/>
                    </Box> : <WorkingCuttingMapTable
                        data={data}
                        setData={setData}
                        queue={true}
                        minNumberCutting={minNumberCutting}
                        maxNumberCutting={maxNumberCutting}
                        unableCut={unableCut}
                        setUnableCut={setUnableCut}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        handleModalAlert={handleModalAlert}
                        enableRowSelection={true}
                        globalFilter={globalFilter}
                        filteredData={filteredData}
                        handleSearchQuery={handleSearchQuery}
                        columnsFilter={columnsFilter}
                    />}
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                    autoHide={false}
                />
            </Box>
        </Box>
    );
};

export default QueueCuttingMaps;